/**
 * Date object that is Timezone independent.
 * 
 * User: scarlson
 * Date: 01/29/13
 * Time: 08:56 PM
 */

define("tzdate", function(require) {
    'use strict';
    var $ = require('jquery'),
        _ = require('underscore'),
        TimezoneJS = require('timezonejs'),
        
        globalize = require('Globalize'),

        DEFAULT_ZONE_FILE = 'southamerica',
        millisInDay = (24*60*60*1000),

        _isValidTimezone = function(theTimezone) {
            try {
                timezoneJS.timezone.zoneFileBasePath = '/js/libs/3rdParty/datetime/tzdata-latest';
                timezoneJS.timezone.defaultZoneFile = DEFAULT_ZONE_FILE;
                $.ajaxSetup({cache: true});
                timezoneJS.timezone.init({async: false});
                $.ajaxSetup({cache: false});

                var theDate = new TimezoneJS.Date(new Date(), theTimezone);

                if (_.isObject(theDate) && theDate.toString('MMM')) {
                    return true;
                } else {
                    console.log('invalid or unmapped timezone: ' + theTimezone);
                    return false;
                }
            } catch (e) {
                console.log('invalid or unmapped timezone: ' + theTimezone);
                return false;
            }
        },

        _getValidTimezone = function(timezone1, timezone2) {
            if (_isValidTimezone(timezone1)) {
                return timezone1;
            } else {
                return timezone2;
            }
        },

        timezone = _getValidTimezone(oeApp.getTimezone(), oeApp.getServerTimezone());
    
    var DateTZ = function(date, format) {

        timezoneJS.timezone.zoneFileBasePath = '/js/libs/3rdParty/datetime/tzdata-latest';
        timezoneJS.timezone.defaultZoneFile = DEFAULT_ZONE_FILE;
        $.ajaxSetup({cache: true});
        timezoneJS.timezone.init({async: false});
        $.ajaxSetup({cache: false});

        if (_.isUndefined(date)) {
            date = new Date();
        } else if (_.isString(date) && _.isString(format)) {
            date = globalize.parseDate(date, format);
        }
        
        var tzdate = new TimezoneJS.Date(date, timezone);
        
        // TODO: SAC: This is clunky at best.
        this.adjustDays = function(offsetDays) {
            var offset = offsetDays * millisInDay;
            
            tzdate = new TimezoneJS.Date(tzdate.getTime() + offset, timezone);
            
            return this;
        };
        
        this.clone = function() {
            return new DateTZ(tzdate);
        };
        
        this.format = function(format) {
            return tzdate.toString(format);
        };
        
        this.getDayLongName = function() {
            return eval('i18n.date.dayOfWeek.long.d' + tzdate.getDay());
        };
        
        this.getDayShortName = function() {
            return eval('i18n.date.dayOfWeek.short.d' + tzdate.getDay());
        };
        
        this.getDate = function() {
            return tzdate.getDate();
        };
        
        this.getDay = function() {
            return tzdate.getDay();
        };
        
        this.getFuzzyDifference = function(otherDatetime) {
            var otherTzdate = new DateTZ(otherDatetime),
                days = Math.round(Math.abs(tzdate.getTime() - otherTzdate.getTime()) / millisInDay),
                weeks = Math.floor(days / 7.0),
                months = Math.floor(weeks / 4.3),
                years = Math.round(months / 12.0);
            
            if (years > 1) return years + ' ' + i18n.years;
            else if (years == 1) return '1 ' + i18n.year;
            else if (months > 1) return months + ' ' + i18n.months;
            else if (months == 1) return '1 ' + i18n.month;
            else if (weeks > 1) return weeks + ' ' + i18n.weeks;
            else if (weeks == 1) return '1 ' + i18n.week;
            else if (days > 1) return days + ' ' + i18n.days;
            else return '1 ' + i18n.day;
        };
        
        this.getMonth = function() {
            return tzdate.getMonth();
        };
        
        this.getMonthLongName = function() {
            return eval('i18n.date.month.long.m' + tzdate.getMonth());
        };
        
        this.getMonthShortName = function() {
            return eval('i18n.date.month.short.m' + tzdate.getMonth());
        };

        this.getWeekOf = function() {
            var lastDigit;
            var start = this.getWeekStartingDate();
             
            if (start == 11 || start == 12 || start == 13) {
                lastDigit = start;
            } else {
                lastDigit = start.toString().substr(start.toString().length-1);
            }
            
            return i18n.date.weekOf.WeekOf + ' ' + start + ({1: i18n.date.st, 2: i18n.date.nd, 3: i18n.date.rd}[lastDigit] || i18n.date.th);
        };
        
        this.getWeekStartingDate = function() {
            var day = tzdate.getDay(),
                monday = (day === 1) ? tzdate : this.adjustDays(-day + 1);
            
            return monday.getDate();
        };
        
        this.isOnOrAfter = function(beforeDate) {
            return (tzdate >= beforeDate.gettzdate());
        };
        
        this.toString = function() {
            return tzdate.toString();
        };
        
        this.getTime = function() {
            return tzdate.getTime();
        },
        
        // TODO: SAC: No - don't do this!
        this.gettzdate = function() {
            return tzdate;
        };
    };
    
    /*
     * Static Fields & Methods
     */
    
    DateTZ.FMT = {
        FULL_DATE: 'dd/MM/yyyy',
        FULL_DATE_MMM: 'dd MMM yyyy',
        NO_YEAR_DATE: 'dd/MM',
        TIME: 'H:mm a'
    };
    
    /*
     * Creates a DateTZ object from numeric components. Uses same conventions as normal
     * Date object (e.g. month is 0 based).
     */
    DateTZ.from = function(timezoneUsed, year, month, day, hour, minute, second, millisecond) {
        timezoneUsed = timezoneUsed || timezone;
        year = year || 0;
        month = month || 0;
        day = day || 0;
        hour = hour || 0;
        minute = minute || 0;
        second = second || 0;
        millisecond = millisecond || 0;

        timezoneJS.timezone.zoneFileBasePath = '/js/libs/3rdParty/datetime/tzdata-latest';
        timezoneJS.timezone.defaultZoneFile = DEFAULT_ZONE_FILE;
        $.ajaxSetup({cache: true});
        timezoneJS.timezone.init({async: false});
        $.ajaxSetup({cache: false});

        var theDate = new TimezoneJS.Date(year, month, day, hour, minute, second, millisecond, _getValidTimezone(timezoneUsed, timezone));
        
        return new DateTZ(theDate.getTime());
    };

    DateTZ.tzFrom = function(theTime, theTimezone) {
        timezoneJS.timezone.zoneFileBasePath = '/js/libs/3rdParty/datetime/tzdata-latest';
        timezoneJS.timezone.defaultZoneFile = DEFAULT_ZONE_FILE;
        $.ajaxSetup({cache: true});
        timezoneJS.timezone.init({async: false});
        $.ajaxSetup({cache: false});

        var theDate = new TimezoneJS.Date(theTime, _getValidTimezone(theTimezone, timezone));

        return theDate;
    }

    DateTZ.tzFormat = function(theTime, format) {
        return theTime.toString(format);
    }

    DateTZ.tzGetDayLongName = function(theTime) {
        return eval('i18n.date.dayOfWeek.long.d' + theTime.getDay());
    }

    DateTZ.tzGetTimezoneOffsetDisplay = function(offset) {
        var offsetRaw = offset,
            offsetAbs = Math.abs(offset),
            offsetHours = Math.floor(offsetAbs / 60),
            offsetMinutes = '' + (offsetAbs % 60);

        if (offsetMinutes.length < 1) offsetMinutes = '00';
        else if (offsetMinutes.length < 2) offsetMinutes = '0' + offsetMinutes;

        return (offsetRaw > 0 ? '-' : '+') + offsetHours + ':' + offsetMinutes;
    }

    DateTZ.tzGetTimezones = function() {
        var dtz = [];

        _.each(DateTZ.TIMEZONES, function(tz){
            dtz[dtz.length] = {
                timezone: tz.timezone,
                offset: tz.offset,
                offsetDisplay: DateTZ.tzGetTimezoneOffsetDisplay(tz.offset)
            };
        });

        dtz = _.sortBy(dtz, function(obj){
            return -1 * obj.offset;
        });

        return dtz;
    }

    DateTZ.TIMEZONES = [
        {timezone: 'Africa/Abidjan', offset: 0},
        {timezone: 'Africa/Accra', offset: 0},
        {timezone: 'Africa/Addis_Ababa', offset: -180},
        {timezone: 'Africa/Algiers', offset: -60},
        {timezone: 'Africa/Asmara', offset: -180},
        {timezone: 'Africa/Bamako', offset: 0},
        {timezone: 'Africa/Bangui', offset: -60},
        {timezone: 'Africa/Banjul', offset: 0},
        {timezone: 'Africa/Bissau', offset: 0},
        {timezone: 'Africa/Blantyre', offset: -120},
        {timezone: 'Africa/Brazzaville', offset: -60},
        {timezone: 'Africa/Bujumbura', offset: -120},
        {timezone: 'Africa/Cairo', offset: -120},
        {timezone: 'Africa/Casablanca', offset: -60},
        {timezone: 'Africa/Ceuta', offset: -120},
        {timezone: 'Africa/Conakry', offset: 0},
        {timezone: 'Africa/Dakar', offset: 0},
        {timezone: 'Africa/Dar_es_Salaam', offset: -180},
        {timezone: 'Africa/Djibouti', offset: -180},
        {timezone: 'Africa/Douala', offset: -60},
        {timezone: 'Africa/El_Aaiun', offset: 0},
        {timezone: 'Africa/Freetown', offset: 0},
        {timezone: 'Africa/Gaborone', offset: -120},
        {timezone: 'Africa/Harare', offset: -120},
        {timezone: 'Africa/Johannesburg', offset: -120},
        {timezone: 'Africa/Kampala', offset: -180},
        {timezone: 'Africa/Khartoum', offset: -180},
        {timezone: 'Africa/Kigali', offset: -120},
        {timezone: 'Africa/Kinshasa', offset: -60},
        {timezone: 'Africa/Lagos', offset: -60},
        {timezone: 'Africa/Libreville', offset: -60},
        {timezone: 'Africa/Lome', offset: 0},
        {timezone: 'Africa/Luanda', offset: -60},
        {timezone: 'Africa/Lubumbashi', offset: -120},
        {timezone: 'Africa/Lusaka', offset: -120},
        {timezone: 'Africa/Malabo', offset: -60},
        {timezone: 'Africa/Maputo', offset: -120},
        {timezone: 'Africa/Maseru', offset: -120},
        {timezone: 'Africa/Mbabane', offset: -120},
        {timezone: 'Africa/Mogadishu', offset: -180},
        {timezone: 'Africa/Monrovia', offset: 0},
        {timezone: 'Africa/Nairobi', offset: -180},
        {timezone: 'Africa/Ndjamena', offset: -60},
        {timezone: 'Africa/Niamey', offset: -60},
        {timezone: 'Africa/Nouakchott', offset: 0},
        {timezone: 'Africa/Ouagadougou', offset: 0},
        {timezone: 'Africa/Porto-Novo', offset: -60},
        {timezone: 'Africa/Sao_Tome', offset: 0},
        {timezone: 'Africa/Tripoli', offset: -120},
        {timezone: 'Africa/Tunis', offset: -60},
        {timezone: 'Africa/Windhoek', offset: -60},
        {timezone: 'America/Adak', offset: 540},
        {timezone: 'America/Anchorage', offset: 480},
        {timezone: 'America/Anguilla', offset: 240},
        {timezone: 'America/Antigua', offset: 240},
        {timezone: 'America/Araguaina', offset: 180},
        {timezone: 'America/Argentina/Buenos_Aires', offset: 180},
        {timezone: 'America/Argentina/Catamarca', offset: 180},
        {timezone: 'America/Argentina/Cordoba', offset: 180},
        {timezone: 'America/Argentina/Jujuy', offset: 180},
        {timezone: 'America/Argentina/La_Rioja', offset: 180},
        {timezone: 'America/Argentina/Mendoza', offset: 180},
        {timezone: 'America/Argentina/Rio_Gallegos', offset: 180},
        {timezone: 'America/Argentina/Salta', offset: 180},
        {timezone: 'America/Argentina/San_Juan', offset: 180},
        {timezone: 'America/Argentina/San_Luis', offset: 240},
        {timezone: 'America/Argentina/Tucuman', offset: 180},
        {timezone: 'America/Argentina/Ushuaia', offset: 180},
        {timezone: 'America/Aruba', offset: 240},
        {timezone: 'America/Asuncion', offset: 240},
        {timezone: 'America/Atikokan', offset: 300},
        {timezone: 'America/Bahia_Banderas', offset: 300},
        {timezone: 'America/Bahia', offset: 180},
        {timezone: 'America/Barbados', offset: 240},
        {timezone: 'America/Belem', offset: 180},
        {timezone: 'America/Belize', offset: 360},
        {timezone: 'America/Blanc-Sablon', offset: 240},
        {timezone: 'America/Boa_Vista', offset: 240},
        {timezone: 'America/Bogota', offset: 300},
        {timezone: 'America/Boise', offset: 360},
        {timezone: 'America/Cambridge_Bay', offset: 360},
        {timezone: 'America/Campo_Grande', offset: 240},
        {timezone: 'America/Cancun', offset: 300},
        {timezone: 'America/Caracas', offset: 270},
        {timezone: 'America/Cayenne', offset: 180},
        {timezone: 'America/Cayman', offset: 300},
        {timezone: 'America/Chicago', offset: 300},
        {timezone: 'America/Chihuahua', offset: 360},
        {timezone: 'America/Costa_Rica', offset: 360},
        {timezone: 'America/Cuiaba', offset: 240},
        {timezone: 'America/Curacao', offset: 240},
        {timezone: 'America/Danmarkshavn', offset: 0},
        {timezone: 'America/Dawson_Creek', offset: 420},
        {timezone: 'America/Dawson', offset: 420},
        {timezone: 'America/Denver', offset: 360},
        {timezone: 'America/Detroit', offset: 240},
        {timezone: 'America/Dominica', offset: 240},
        {timezone: 'America/Edmonton', offset: 360},
        {timezone: 'America/Eirunepe', offset: 240},
        {timezone: 'America/El_Salvador', offset: 360},
        {timezone: 'America/Fortaleza', offset: 180},
        {timezone: 'America/Glace_Bay', offset: 180},
        {timezone: 'America/Godthab', offset: 120},
        {timezone: 'America/Goose_Bay', offset: 180},
        {timezone: 'America/Grand_Turk', offset: 240},
        {timezone: 'America/Grenada', offset: 240},
        {timezone: 'America/Guadeloupe', offset: 240},
        {timezone: 'America/Guatemala', offset: 360},
        {timezone: 'America/Guayaquil', offset: 300},
        {timezone: 'America/Guyana', offset: 240},
        {timezone: 'America/Halifax', offset: 180},
        {timezone: 'America/Havana', offset: 240},
        {timezone: 'America/Hermosillo', offset: 420},
        {timezone: 'America/Indiana/Indianapolis', offset: 240},
        {timezone: 'America/Indiana/Knox', offset: 300},
        {timezone: 'America/Indiana/Marengo', offset: 240},
        {timezone: 'America/Indiana/Petersburg', offset: 240},
        {timezone: 'America/Indiana/Tell_City', offset: 300},
        {timezone: 'America/Indiana/Vevay', offset: 240},
        {timezone: 'America/Indiana/Vincennes', offset: 240},
        {timezone: 'America/Indiana/Winamac', offset: 240},
        {timezone: 'America/Inuvik', offset: 360},
        {timezone: 'America/Iqaluit', offset: 240},
        {timezone: 'America/Jamaica', offset: 300},
        {timezone: 'America/Juneau', offset: 480},
        {timezone: 'America/Kentucky/Louisville', offset: 240},
        {timezone: 'America/Kentucky/Monticello', offset: 240},
        {timezone: 'America/La_Paz', offset: 240},
        {timezone: 'America/Lima', offset: 300},
        {timezone: 'America/Los_Angeles', offset: 420},
        {timezone: 'America/Maceio', offset: 180},
        {timezone: 'America/Managua', offset: 360},
        {timezone: 'America/Manaus', offset: 240},
        {timezone: 'America/Marigot', offset: 240},
        {timezone: 'America/Martinique', offset: 240},
        {timezone: 'America/Matamoros', offset: 300},
        {timezone: 'America/Mazatlan', offset: 360},
        {timezone: 'America/Menominee', offset: 300},
        {timezone: 'America/Merida', offset: 300},
        {timezone: 'America/Metlakatla', offset: 480},
        {timezone: 'America/Mexico_City', offset: 300},
        {timezone: 'America/Miquelon', offset: 120},
        {timezone: 'America/Moncton', offset: 180},
        {timezone: 'America/Monterrey', offset: 300},
        {timezone: 'America/Montevideo', offset: 180},
        {timezone: 'America/Montreal', offset: 240},
        {timezone: 'America/Montserrat', offset: 240},
        {timezone: 'America/Nassau', offset: 240},
        {timezone: 'America/New_York', offset: 240},
        {timezone: 'America/Nipigon', offset: 240},
        {timezone: 'America/Nome', offset: 480},
        {timezone: 'America/Noronha', offset: 120},
        {timezone: 'America/North_Dakota/Beulah', offset: 300},
        {timezone: 'America/North_Dakota/Center', offset: 300},
        {timezone: 'America/North_Dakota/New_Salem', offset: 300},
        {timezone: 'America/Ojinaga', offset: 360},
        {timezone: 'America/Panama', offset: 300},
        {timezone: 'America/Pangnirtung', offset: 240},
        {timezone: 'America/Paramaribo', offset: 180},
        {timezone: 'America/Phoenix', offset: 420},
        {timezone: 'America/Port_of_Spain', offset: 240},
        {timezone: 'America/Port-au-Prince', offset: 240},
        {timezone: 'America/Porto_Velho', offset: 240},
        {timezone: 'America/Puerto_Rico', offset: 240},
        {timezone: 'America/Rainy_River', offset: 300},
        {timezone: 'America/Rankin_Inlet', offset: 300},
        {timezone: 'America/Recife', offset: 180},
        {timezone: 'America/Regina', offset: 360},
        {timezone: 'America/Resolute', offset: 300},
        {timezone: 'America/Rio_Branco', offset: 240},
        {timezone: 'America/Santa_Isabel', offset: 420},
        {timezone: 'America/Santarem', offset: 180},
        {timezone: 'America/Santiago', offset: 240},
        {timezone: 'America/Santo_Domingo', offset: 240},
        {timezone: 'America/Sao_Paulo', offset: 180},
        {timezone: 'America/Scoresbysund', offset: 0},
        {timezone: 'America/Shiprock', offset: 360},
        {timezone: 'America/Sitka', offset: 480},
        {timezone: 'America/St_Barthelemy', offset: 240},
        {timezone: 'America/St_Johns', offset: 150},
        {timezone: 'America/St_Kitts', offset: 240},
        {timezone: 'America/St_Lucia', offset: 240},
        {timezone: 'America/St_Thomas', offset: 240},
        {timezone: 'America/St_Vincent', offset: 240},
        {timezone: 'America/Swift_Current', offset: 360},
        {timezone: 'America/Tegucigalpa', offset: 360},
        {timezone: 'America/Thule', offset: 180},
        {timezone: 'America/Thunder_Bay', offset: 240},
        {timezone: 'America/Tijuana', offset: 420},
        {timezone: 'America/Toronto', offset: 240},
        {timezone: 'America/Tortola', offset: 240},
        {timezone: 'America/Vancouver', offset: 420},
        {timezone: 'America/Whitehorse', offset: 420},
        {timezone: 'America/Winnipeg', offset: 300},
        {timezone: 'America/Yakutat', offset: 480},
        {timezone: 'America/Yellowknife', offset: 360},
        {timezone: 'Antarctica/Casey', offset: -480},
        {timezone: 'Antarctica/Davis', offset: -420},
        {timezone: 'Antarctica/DumontDUrville', offset: -600},
        {timezone: 'Antarctica/Macquarie', offset: -660},
        {timezone: 'Antarctica/Mawson', offset: -300},
        {timezone: 'Antarctica/McMurdo', offset: -720},
        {timezone: 'Antarctica/Palmer', offset: 240},
        {timezone: 'Antarctica/Rothera', offset: 180},
        {timezone: 'Antarctica/South_Pole', offset: -720},
        {timezone: 'Antarctica/Syowa', offset: -180},
        {timezone: 'Antarctica/Vostok', offset: -360},
        {timezone: 'Arctic/Longyearbyen', offset: -120},
        {timezone: 'Asia/Aden', offset: -180},
        {timezone: 'Asia/Almaty', offset: -360},
        {timezone: 'Asia/Amman', offset: -180},
        {timezone: 'Asia/Anadyr', offset: -720},
        {timezone: 'Asia/Aqtau', offset: -300},
        {timezone: 'Asia/Aqtobe', offset: -300},
        {timezone: 'Asia/Ashgabat', offset: -300},
        {timezone: 'Asia/Baghdad', offset: -180},
        {timezone: 'Asia/Bahrain', offset: -180},
        {timezone: 'Asia/Baku', offset: -300},
        {timezone: 'Asia/Bangkok', offset: -420},
        {timezone: 'Asia/Beirut', offset: -180},
        {timezone: 'Asia/Bishkek', offset: -360},
        {timezone: 'Asia/Brunei', offset: -480},
        {timezone: 'Asia/Choibalsan', offset: -480},
        {timezone: 'Asia/Chongqing', offset: -480},
        {timezone: 'Asia/Colombo', offset: -330},
        {timezone: 'Asia/Damascus', offset: -180},
        {timezone: 'Asia/Dhaka', offset: -360},
        {timezone: 'Asia/Dili', offset: -540},
        {timezone: 'Asia/Dubai', offset: -240},
        {timezone: 'Asia/Dushanbe', offset: -300},
        {timezone: 'Asia/Gaza', offset: -120},
        {timezone: 'Asia/Harbin', offset: -480},
        {timezone: 'Asia/Ho_Chi_Minh', offset: -420},
        {timezone: 'Asia/Hong_Kong', offset: -480},
        {timezone: 'Asia/Hovd', offset: -420},
        {timezone: 'Asia/Irkutsk', offset: -540},
        {timezone: 'Asia/Jakarta', offset: -420},
        {timezone: 'Asia/Jayapura', offset: -540},
        {timezone: 'Asia/Jerusalem', offset: -180},
        {timezone: 'Asia/Kabul', offset: -270},
        {timezone: 'Asia/Kamchatka', offset: -720},
        {timezone: 'Asia/Karachi', offset: -300},
        {timezone: 'Asia/Kashgar', offset: -480},
        {timezone: 'Asia/Kathmandu', offset: -345},
        {timezone: 'Asia/Kolkata', offset: -330},
        {timezone: 'Asia/Krasnoyarsk', offset: -480},
        {timezone: 'Asia/Kuala_Lumpur', offset: -480},
        {timezone: 'Asia/Kuching', offset: -480},
        {timezone: 'Asia/Kuwait', offset: -180},
        {timezone: 'Asia/Macau', offset: -480},
        {timezone: 'Asia/Magadan', offset: -720},
        {timezone: 'Asia/Makassar', offset: -480},
        {timezone: 'Asia/Manila', offset: -480},
        {timezone: 'Asia/Muscat', offset: -240},
        {timezone: 'Asia/Nicosia', offset: -180},
        {timezone: 'Asia/Novokuznetsk', offset: -420},
        {timezone: 'Asia/Novosibirsk', offset: -420},
        {timezone: 'Asia/Omsk', offset: -420},
        {timezone: 'Asia/Oral', offset: -300},
        {timezone: 'Asia/Phnom_Penh', offset: -420},
        {timezone: 'Asia/Pontianak', offset: -420},
        {timezone: 'Asia/Pyongyang', offset: -540},
        {timezone: 'Asia/Qatar', offset: -180},
        {timezone: 'Asia/Qyzylorda', offset: -360},
        {timezone: 'Asia/Rangoon', offset: -390},
        {timezone: 'Asia/Riyadh', offset: -180},
        {timezone: 'Asia/Sakhalin', offset: -660},
        {timezone: 'Asia/Samarkand', offset: -300},
        {timezone: 'Asia/Seoul', offset: -540},
        {timezone: 'Asia/Shanghai', offset: -480},
        {timezone: 'Asia/Singapore', offset: -480},
        {timezone: 'Asia/Taipei', offset: -480},
        {timezone: 'Asia/Tashkent', offset: -300},
        {timezone: 'Asia/Tbilisi', offset: -240},
        {timezone: 'Asia/Tehran', offset: -270},
        {timezone: 'Asia/Thimphu', offset: -360},
        {timezone: 'Asia/Tokyo', offset: -540},
        {timezone: 'Asia/Ulaanbaatar', offset: -480},
        {timezone: 'Asia/Urumqi', offset: -480},
        {timezone: 'Asia/Vientiane', offset: -420},
        {timezone: 'Asia/Vladivostok', offset: -660},
        {timezone: 'Asia/Yakutsk', offset: -600},
        {timezone: 'Asia/Yekaterinburg', offset: -360},
        {timezone: 'Asia/Yerevan', offset: -240},
        {timezone: 'Atlantic/Azores', offset: 0},
        {timezone: 'Atlantic/Bermuda', offset: 180},
        {timezone: 'Atlantic/Canary', offset: -60},
        {timezone: 'Atlantic/Cape_Verde', offset: 60},
        {timezone: 'Atlantic/Faroe', offset: -60},
        {timezone: 'Atlantic/Madeira', offset: -60},
        {timezone: 'Atlantic/Reykjavik', offset: 0},
        {timezone: 'Atlantic/South_Georgia', offset: 120},
        {timezone: 'Atlantic/St_Helena', offset: 0},
        {timezone: 'Atlantic/Stanley', offset: 180},
        {timezone: 'Australia/Adelaide', offset: -570},
        {timezone: 'Australia/Brisbane', offset: -600},
        {timezone: 'Australia/Broken_Hill', offset: -570},
        {timezone: 'Australia/Currie', offset: -600},
        {timezone: 'Australia/Darwin', offset: -570},
        {timezone: 'Australia/Eucla', offset: -525},
        {timezone: 'Australia/Hobart', offset: -600},
        {timezone: 'Australia/Lindeman', offset: -600},
        {timezone: 'Australia/Lord_Howe', offset: -630},
        {timezone: 'Australia/Melbourne', offset: -600},
        {timezone: 'Australia/Perth', offset: -480},
        {timezone: 'Australia/Sydney', offset: -600},
        {timezone: 'Europe/Amsterdam', offset: -120},
        {timezone: 'Europe/Andorra', offset: -120},
        {timezone: 'Europe/Athens', offset: -180},
        {timezone: 'Europe/Belgrade', offset: -120},
        {timezone: 'Europe/Berlin', offset: -120},
        {timezone: 'Europe/Bratislava', offset: -120},
        {timezone: 'Europe/Brussels', offset: -120},
        {timezone: 'Europe/Bucharest', offset: -180},
        {timezone: 'Europe/Budapest', offset: -120},
        {timezone: 'Europe/Chisinau', offset: -180},
        {timezone: 'Europe/Copenhagen', offset: -120},
        {timezone: 'Europe/Dublin', offset: -60},
        {timezone: 'Europe/Gibraltar', offset: -120},
        {timezone: 'Europe/Guernsey', offset: -60},
        {timezone: 'Europe/Helsinki', offset: -180},
        {timezone: 'Europe/Isle_of_Man', offset: -60},
        {timezone: 'Europe/Istanbul', offset: -180},
        {timezone: 'Europe/Jersey', offset: -60},
        {timezone: 'Europe/Kaliningrad', offset: -180},
        {timezone: 'Europe/Kiev', offset: -180},
        {timezone: 'Europe/Lisbon', offset: -60},
        {timezone: 'Europe/Ljubljana', offset: -120},
        {timezone: 'Europe/London', offset: -60},
        {timezone: 'Europe/Luxembourg', offset: -120},
        {timezone: 'Europe/Madrid', offset: -120},
        {timezone: 'Europe/Malta', offset: -120},
        {timezone: 'Europe/Mariehamn', offset: -180},
        {timezone: 'Europe/Minsk', offset: -180},
        {timezone: 'Europe/Monaco', offset: -120},
        {timezone: 'Europe/Moscow', offset: -240},
        {timezone: 'Europe/Oslo', offset: -120},
        {timezone: 'Europe/Paris', offset: -120},
        {timezone: 'Europe/Podgorica', offset: -120},
        {timezone: 'Europe/Prague', offset: -120},
        {timezone: 'Europe/Riga', offset: -180},
        {timezone: 'Europe/Rome', offset: -120},
        {timezone: 'Europe/Samara', offset: -240},
        {timezone: 'Europe/San_Marino', offset: -120},
        {timezone: 'Europe/Sarajevo', offset: -120},
        {timezone: 'Europe/Simferopol', offset: -180},
        {timezone: 'Europe/Skopje', offset: -120},
        {timezone: 'Europe/Sofia', offset: -180},
        {timezone: 'Europe/Stockholm', offset: -120},
        {timezone: 'Europe/Tallinn', offset: -180},
        {timezone: 'Europe/Tirane', offset: -120},
        {timezone: 'Europe/Uzhgorod', offset: -180},
        {timezone: 'Europe/Vaduz', offset: -120},
        {timezone: 'Europe/Vatican', offset: -120},
        {timezone: 'Europe/Vienna', offset: -120},
        {timezone: 'Europe/Vilnius', offset: -180},
        {timezone: 'Europe/Volgograd', offset: -240},
        {timezone: 'Europe/Warsaw', offset: -120},
        {timezone: 'Europe/Zagreb', offset: -120},
        {timezone: 'Europe/Zaporozhye', offset: -180},
        {timezone: 'Europe/Zurich', offset: -120},
        {timezone: 'Indian/Antananarivo', offset: -180},
        {timezone: 'Indian/Chagos', offset: -360},
        {timezone: 'Indian/Christmas', offset: -420},
        {timezone: 'Indian/Cocos', offset: -390},
        {timezone: 'Indian/Comoro', offset: -180},
        {timezone: 'Indian/Kerguelen', offset: -300},
        {timezone: 'Indian/Mahe', offset: -240},
        {timezone: 'Indian/Maldives', offset: -300},
        {timezone: 'Indian/Mauritius', offset: -240},
        {timezone: 'Indian/Mayotte', offset: -180},
        {timezone: 'Indian/Reunion', offset: -240},
        {timezone: 'Pacific/Apia', offset: -780},
        {timezone: 'Pacific/Auckland', offset: -720},
        {timezone: 'Pacific/Chatham', offset: -765},
        {timezone: 'Pacific/Chuuk', offset: -600},
        {timezone: 'Pacific/Easter', offset: 360},
        {timezone: 'Pacific/Efate', offset: -660},
        {timezone: 'Pacific/Enderbury', offset: -780},
        {timezone: 'Pacific/Fakaofo', offset: -780},
        {timezone: 'Pacific/Fiji', offset: -720},
        {timezone: 'Pacific/Funafuti', offset: -720},
        {timezone: 'Pacific/Galapagos', offset: 360},
        {timezone: 'Pacific/Gambier', offset: 540},
        {timezone: 'Pacific/Guadalcanal', offset: -660},
        {timezone: 'Pacific/Guam', offset: -600},
        {timezone: 'Pacific/Honolulu', offset: 600},
        {timezone: 'Pacific/Johnston', offset: 600},
        {timezone: 'Pacific/Kiritimati', offset: -840},
        {timezone: 'Pacific/Kosrae', offset: -660},
        {timezone: 'Pacific/Kwajalein', offset: -720},
        {timezone: 'Pacific/Majuro', offset: -720},
        {timezone: 'Pacific/Marquesas', offset: 570},
        {timezone: 'Pacific/Midway', offset: 660},
        {timezone: 'Pacific/Nauru', offset: -720},
        {timezone: 'Pacific/Niue', offset: 660},
        {timezone: 'Pacific/Norfolk', offset: -690},
        {timezone: 'Pacific/Noumea', offset: -660},
        {timezone: 'Pacific/Pago_Pago', offset: 660},
        {timezone: 'Pacific/Palau', offset: -540},
        {timezone: 'Pacific/Pitcairn', offset: 480},
        {timezone: 'Pacific/Pohnpei', offset: -660},
        {timezone: 'Pacific/Port_Moresby', offset: -600},
        {timezone: 'Pacific/Rarotonga', offset: 600},
        {timezone: 'Pacific/Saipan', offset: -600},
        {timezone: 'Pacific/Tahiti', offset: 600},
        {timezone: 'Pacific/Tarawa', offset: -720},
        {timezone: 'Pacific/Tongatapu', offset: -780},
        {timezone: 'Pacific/Wake', offset: -720},
        {timezone: 'Pacific/Wallis', offset: -720}
    ];

    return DateTZ;
});



//////////////////
// WEBPACK FOOTER
// ./js/libs/custom/tzdate.js
// module id = 256
// module chunks = 27 28 29